import { render, staticRenderFns } from "./line-tip.vue?vue&type=template&id=1ead3840"
import script from "./line-tip.vue?vue&type=script&lang=js"
export * from "./line-tip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports